import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { fetchCompany } from '../api/endpoints'

/**
 * Running footer on every printed page: company name and a page number.
 * Fixed positioning is what makes print engines repeat it per sheet.
 */
export default function ReportFooter() {
  const { t } = useTranslation()
  const { data: co } = useQuery({ queryKey: ['company'], queryFn: fetchCompany })
  return (
    <div className="print-only print-footer">
      <span>{co?.name_en}</span>
      <span>{t('report.page')} <span className="page-number" /></span>
    </div>
  )
}
